import { useState, useEffect } from 'react';
import { generateKindnessId } from '../utils/kindnessId';

export const useKindnessId = () => {
  const [kindnessId, setKindnessId] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const savedId = localStorage.getItem('nakamoto-kindness-id');
    if (savedId) {
      setKindnessId(savedId);
    } else {
      setShowModal(true);
    }
  }, []);

  const handleSetKindnessId = (id) => {
    if (id === 'generate') {
      const newId = generateKindnessId();
      setKindnessId(newId);
      localStorage.setItem('nakamoto-kindness-id', newId);
    } else {
      setKindnessId(id);
      localStorage.setItem('nakamoto-kindness-id', id);
    }
    setShowModal(false);
  };

  return {
    kindnessId,
    showModal,
    setShowModal,
    setKindnessId: handleSetKindnessId
  };
};